import React from 'react';
import { deleteAnnoucementData, getAnnouncement } from '../../service/adminApi';
import { getTimestampToDate } from '../../utils/dateConvetor';
import Popup from '../ConformationPopup/Popup';

function AnnouncementGrid({ editAnnouncement, updateData, setIsLoading }) {
    const [announcementData, setAnnouncementData] = React.useState([]);
    const [deleteIndex, setDeleteIndex] = React.useState();
    const [sortIcon, setSortIcon] = React.useState(false);

    React.useEffect(() => {
        getAnnouncementData();
    }, [updateData]);

    const getAnnouncementData = async () => {
        const response = await getAnnouncement();

        if (response) setIsLoading();
        setAnnouncementData(response.data.data);
    };

    const deleteAnnouncement = async () => {
        const response = await deleteAnnoucementData({
            id: announcementData[deleteIndex].id,
            is_active: false,
        });
        if (response.data.statusCode === 200) {
            getAnnouncementData();
        }
    };

    const bindAnnouncement = () => {
        return announcementData.map((data, index) => {
            let startDate = getTimestampToDate(data.start_date, 3);
            let endDate = getTimestampToDate(data.end_date, 3);
            let comments;
            if (data.description.length > 25) {
                comments = data.description.substring(0, 25);
                comments = comments + '...';
            } else comments = data.description;
            return (
                <tr className="hive-table-data regular-text align-middle" key={index}>
                    <td>{data.title}</td>
                    <td>
                        {startDate} - {endDate}
                    </td>
                    <td data-bs-toggle="tooltip" data-bs-placement="top" title={data.description}>
                        {comments}
                    </td>
                    <td className="text-center">
                        <a
                            onClick={() => {
                                editAnnouncement(data);
                            }}
                            className=" ms-2"
                            alt=""
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight"
                            aria-controls="offcanvasRight"
                        >
                            <img src="/Images/edit1.svg" className="ms-1" alt="bin" />
                        </a>
                        <a
                            data-bs-toggle="modal"
                            data-bs-target="#logout"
                            onClick={() => {
                                setDeleteIndex(index);
                            }}
                            className="ps-4"
                            alt=""
                        >
                            <img src="/Images/bin.svg" className="ms-3" alt="close" />
                        </a>
                    </td>
                </tr>
            );
        });
    };

    const getSortData = async (order) => {
        const response = await getAnnouncement({ sort: order });
        setAnnouncementData(response.data.data);
    };

    return (
        <div className="col-md-12 mb-5">
            <div className="tab-content" id="pills-tabContent">
                {/*All Leave Request Section Starts Here*/}
                <div
                    className="tab-pane fade show active mt-4"
                    id="all_leave_request"
                    role="tabpanel"
                    aria-labelledby="all_leave_request_tab"
                >
                    <div className="table-responsive rounded-3">
                        {announcementData.length > 0 ? (
                            <table className="table bg-white hive-grid table-borderless">
                                <thead className="hive-table-head ">
                                    <tr>
                                        <th className="bold-text font-12">
                                            Title
                                            {sortIcon ? (
                                                <span className="ps-2">
                                                    <img
                                                        src="/Images/Sort-up.svg"
                                                        onClick={() => {
                                                            getSortData('asc');
                                                            setSortIcon(!sortIcon);
                                                        }}
                                                        alt="Sorticon"
                                                        className="hive-table-sort"
                                                    />
                                                </span>
                                            ) : (
                                                <span className="ps-2">
                                                    <img
                                                        src="/Images/sort-icon.svg"
                                                        onClick={() => {
                                                            getSortData('desc');
                                                            setSortIcon(!sortIcon);
                                                        }}
                                                        alt="Sorticon"
                                                        className="hive-table-sort"
                                                    />
                                                </span>
                                            )}
                                        </th>
                                        <th className="bold-text font-12">Date Range</th>
                                        <th className="bold-text font-12">Comments</th>
                                        <th className="text-center bold-text font-12">Action</th>
                                    </tr>
                                </thead>
                                <tbody>{bindAnnouncement()}</tbody>
                            </table>
                        ) : (
                            <div className="row justify-content-center  w-100">
                                <img src="/Images/nodatafound.png" alt="no-records" style={{ width: 700, height: 500 }} />
                                <span className="row justify-content-center tt-bold font-16">No Announcement Found</span>
                            </div>
                        )}
                    </div>
                </div>

                <div
                    className="tab-pane fade show active"
                    id="my_leave_request"
                    role="tabpanel"
                    aria-labelledby="my_leave_request_tab"
                ></div>
                {/*My Leave Request Section Ends Here*/}
                {/*WFH Request Section Starts Here*/}
                <div className="tab-pane fade show active" id="wfh_request" role="tabpanel" aria-labelledby="wfh_request_tab"></div>
                {/*WFH Request Section Ends Here*/}
                {/*My WFH Request Section Starts Here*/}
                <div className="tab-pane fade show active" id="my_wfh_request" role="tabpanel" aria-labelledby="my_wfh_request_tab"></div>
                {/*My WFH Request Section Ends Here*/}
            </div>
            <Popup
                deleteData={() => {
                    deleteAnnouncement();
                }}
            />
        </div>
    );
}

export default AnnouncementGrid;
